import useAsyncData from "../../../../hooks/use-async-data";
import contractsService from "../../contracts.service";
import ContractsMileageCargoCompanyDetails from "./contracts-mileage-cargo-company-details";
import ContractsMileageCargoCompanyDetailsParams from "./contracts-mileage-cargo-company-details-params";

const useContractsMileageCargoCompanyDetails = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<ContractsMileageCargoCompanyDetails | null>(null);

  const load = async (
    loadParams: ContractsMileageCargoCompanyDetailsParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsError(false);
    setIsLoading(true);

    try {
      const data = await contractsService.getContractMileageCargoCompanyDetails(
        loadParams,
        signal,
      );

      setData(data);
    } catch {
      setData(null);
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useContractsMileageCargoCompanyDetails;
